import React from 'react';
import { DialogContentType, IconNames, NoCrNoHDialog } from '@dotcom/crown-ui';
import { useHplusContents, useLoyaltyContents } from './hooks';
import { NoCrNoHDialogProps } from './no-cr-no-h-dialog-types';
import styles from './no-cr-no-h-dialog.module.scss';

export const NoCrNoH = ({ isOpen, setIsOpen, isLoyaltyCtaVisible }: NoCrNoHDialogProps) => {
  const { hPlusContainerContent } = useHplusContents();
  const { loyaltyContainerContents } = useLoyaltyContents();

  const handleCloseDialog = () => {
    setIsOpen(false);
  };

  return (
    <>
      <NoCrNoHDialog
        isOpen={isOpen}
        onClose={handleCloseDialog}
        id="no-cr-no-h-dialog"
        accentIcon={IconNames.PersonPerson}
        hasGrayBackground={true}
        closeButtonId="no-cr-no-h-dialog-close-button"
        hideOverlay={false}
        type={DialogContentType.FeatureModal}
        disableDialogScroll={true}
        testId="no-cr-no-h-dialog"
        firstContainer={isLoyaltyCtaVisible ? loyaltyContainerContents : null}
        secondContainer={hPlusContainerContent}
        addDialogClass={styles['dialog-no-cr-no-h']}
      />
    </>
  );
};
